import type { FaireProductEntity } from "../../entity_types/product";

export const p_yhjamy2pjq: FaireProductEntity = {
  token: "p_yhjamy2pjq",
  type: "product",
  name: "Vibrant Scalp Sampling Bundle",
  brandToken: "b_e14vlockdx",
  brandName: "NULASTIN",
  imageUrl: "https://cdn.faire.com/fastly/4bcf4d9133ba3042aac6acaf24ebbda8fe06438475b920fdc5cf8e374fe9b62e.jpeg",
  galleryImageUrls: [],
  priceDollars: 77.5,
  description: "A complete, elastin focused scalp ritual designed to support fuller-looking, healthier hair from the root. This professional sampling set includes our Vibrant Scalp Treatment, Shampoo, Conditioner, and Scrub, along with NuProtect™ Leave-In Primer and our Scalp Massager — delivering a comprehensive introduction to the Vibrant Scalp System and its root-supporting technology.\n\n1x Vibrant Scalp Treatment \n\n1x Vibrant Scalp Shampoo\n\n1x Vibrant Scalp Conditioner\n\n1x Vibrant Scalp Scrub\n\n1x NuProtect Leave-In Primer\n\n1x Vibrant Scalp Massager\n",
  tags: [],
  msrpDollars: 310,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:24.480Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
